"use client";

import { useEffect } from "react";
import { vouchForMagicLink } from "../utils/magic-link-channel";

/**
 * While `isWaitingForMagicLink`, lets a magic link opened in another tab of this browser verify
 * without a click. Unlike `useMagicLinkListener`, this tab keeps showing what it has: the tab the
 * link opened in goes on to the callback URL.
 */
export function useMagicLinkVoucher(isWaitingForMagicLink: boolean) {
  useEffect(() => {
    if (!isWaitingForMagicLink) return;

    return vouchForMagicLink();
  }, [isWaitingForMagicLink]);
}
